import React from 'react'
import PropTypes from 'prop-types'

import { SlotContext } from './context'

// Experimental feature
const SlotHostComponent = ({ hostController, children }) => {
  return (
    <SlotContext.Provider value={hostController}>
      {children}
    </SlotContext.Provider>
  )
}

SlotHostComponent.propTypes = {
  hostController: PropTypes.shape(),
  children: PropTypes.node,
}

export default SlotHostComponent
